const ecpRoutes = [
  {
    path: "/ecp",
    name: "",
    meta: {
      title: "프로그램",
      isDynamic: true,
    },
    children: [
      /** 프로그램 신청 */
      {
        path: "reg", // /ecp/reg
        name: "ecpRegIndex",
        meta: {
          title: "프로그램 등록",
          titleEn: "Extracurricular Activities Registration",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegIndex.vue"),
      },
      {
        path: "reg/detail", // /ecp/reg/detail
        name: "ecpRegDetail",
        meta: {
          title: "프로그램 등록 상세",
          titleEn: "Extracurricular Activities Registration Detail",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegDetail.vue"),
      },
      /** 프로그램 운영 */
      {
        path: "oper", // /ecp/oper
        name: "ecpOperIndex",
        meta: {
          title: "프로그램 운영",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpOperIndex.vue"),
      },
      {
        path: "setting", // /ecp/oper/setting
        name: "ecpSetting",
        meta: {
          title: "프로그램 설정",
          titleEn: "Extracurricular Activities Setting",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpSetting.vue"),
      },
      /** 평생교육 */
      {
        path: "lifelong-edu", // /ecp/lifelong-edu
        name: "lifelongEduStaffIndex",
        meta: {
          title: "평생교육",
          titleEn: "Lifelong Education",
          menuCd: "STAFF_LIFELONG",
          isDynamic: true,
        },
        component: () => import("@/views/staff/ecp/lifelong-edu/LifelongEduStaffIndex.vue"),
      },
      /** 프로그램 신청 */
      {
        path: "staff-apply", // /ecp/staff-apply
        name: "ecpApplyIndex",
        meta: {
          title: "프로그램 신청",
          titleEn: "Extracurricular Activities Apply",
          menuCd: "STAFF_ECP_APPLY",
          isDynamic: true,
        },
        component: () => import("@/views/staff/ecp/apply/StaffEcpApplyIndex.vue"),
      },
      /** 프로그램 상세 */
      {
        path: "detail/:ecpId", // /ecp/detail/:ecpId
        name: "ecpDetail",
        meta: {
          title: "프로그램 신청 상세",
          mobileHd: true,
          mobileTitle: "프로그램 신청",
          titleEn: "Extracurricular Activities Apply Detail",
          menuCd: "STAFF_ECP_APPLY",
          isDynamic: false,
          likeBtn: true,
          site: "inha",
        },
        //@only_inha
        component: () => import("@/views/student/ecp/apply/EcpDetail-inha.vue"),
      },
      /* 나의 프로그램 */
      {
        path: "staff-my-ecp",
        name: "myEcp",
        children: [
          {
            path: "", // /ecp/staff-my-ecp
            name: "myEcpIndex",
            meta: {
              title: "나의 프로그램",
              titleEn: "My Extracurricular Activities",
              menuCd: "STAFF_MY_ECP",
              isDynamic: true,
            },
            component: () => import("@/views/student/ecp/my-ecp/MyEcpIndex.vue"),
          },
          /* 3-2. 강의실 */
          {
            path: "classroom", // /ecp/staff-my-ecp/classroom
            name: "myEcpClassroom",
            meta: {
              title: "강의실",
              titleEn: "Classroom",
              menuCd: "STAFF_MY_ECP",
              isDynamic: true,
            },
            component: () => import("@/views/student/ecp/my-ecp/MyEcpClassroomIndex.vue"),
          },
        ],
      },
    ],
  },
];
export default ecpRoutes;
